<template>
  <div class="vqb-children">
    <template v-for="(child, index) in query.children">
      <div
        v-if="
          index > 0 && child.query.rule && $parent.ruleById(child.query.rule)
        "
        :key="'operator_' + index"
        class="pb-4"
      >
        {{ query.logicalOperator === "all" ? "AND" : "OR" }}
      </div>
      <component
        :is="getComponent(child.type)"
        :key="index"
        :type="child.type"
        :query.sync="child.query"
        :rule-types="ruleTypes"
        :rules="rules"
        :rule="$parent.ruleById(child.query.rule)"
        :index="index"
        :max-depth="maxDepth"
        :depth="depth + 1"
        :labels="labels"
        :locked="locked"
        @child-deletion-requested="$parent.removeChild"
      />
    </template>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: [
    "query",
    "ruleTypes",
    "rules",
    "maxDepth",
    "labels",
    "depth",
    "locked"
  ],

  data() {
    return {
      groupComponent: null,
      ruleComponent: null
    };
  },

  mounted() {
    this.groupComponent = this.$parent.$options.components["QueryBuilderGroup"];
    this.ruleComponent = this.$parent.$options.components["QueryBuilderRule"];
  },

  methods: {
    getComponent(type) {
      return type === "query-builder-group"
        ? this.groupComponent
        : this.ruleComponent;
    }
  }
};
</script>
